﻿document.addEventListener('DOMContentLoaded', function () {
    InputMask.Init()
})

export class InputMask {
    public static Init(): void {
        document.querySelectorAll('[mask]')?.forEach(triggerElement => {
            triggerElement.addEventListener('keydown', (event) => {
                let evt = event as KeyboardEvent
                let el = event.target as HTMLInputElement
                let mask = el.getAttribute('mask')

                //const cursorPosition = el.selectionStart ?? 0;
                //const nextChar = el.value[cursorPosition];
                //const prevChar = el.value[cursorPosition - 1];

                // Allow arrow keys, home, and end keys
                if (evt.key == 'Backspace' || evt.key == 'Tab' || evt.key === 'ArrowLeft' || evt.key === 'ArrowRight' || evt.key === 'Home' || evt.key === 'End' || evt.key === 'ArrowUp' || evt.key === 'ArrowDown') {
                    return; // Do nothing, allow the keypress
                }

                if (mask == 'phone' || mask == 'ssn') {
                    if (evt.key?.match(/[0-9]|-/g)) {
                        let startHyphenLoc = 3
                        let endHyphenLoc = mask == 'phone' ? 7 : 6

                        if (evt.key == '-') {
                            if (el.selectionStart == startHyphenLoc || el.selectionStart == endHyphenLoc) {
                                //allow hyphen

                            }
                            else {
                                event.preventDefault()
                            }
                        }
                        else {
                            // any number
                            if (el.selectionStart == startHyphenLoc || el.selectionStart == endHyphenLoc) {
                                // you've typed a number so auto insert hyphen
                                el.value += '-'
                            }
                        }
                    }
                    else {
                        event.preventDefault()
                    }
                }
            })
        })
    }
}

declare global {
    interface Window {
        InputMask: typeof InputMask;
    }
}

window.InputMask = InputMask